import * as React from "react";
import DocumentTitle from "react-document-title";
import Grid from "@material-ui/core/Grid";
import { observer } from "mobx-react-lite";
import { AdminsProfilesTable } from "../../features/Tables/AdminsProfilesTable/AdminsProfilesTable";
import { UserRoleEnum } from "../../static/enums/UserRole";
import { useGetUsers } from "../../helpers/hooks/useGetUsers";
import { uiStore } from "../../mobx/stores/UiStore/UiStore";

export const AdminsProfilesPage = observer(() => {
  const { loading } = uiStore;
  useGetUsers({
    role: UserRoleEnum.admin,
  });

  return (
    <DocumentTitle title={"Администраторы - Mindset.Digital"}>
      <Grid container spacing={3}>
        <AdminsProfilesTable loading={loading} />
      </Grid>
    </DocumentTitle>
  );
});
